import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Col, Form, Label, Row } from "reactstrap"
import Select from "react-select"
import Flatpickr from "react-flatpickr"
import moment from "moment"

const AdjustmentActionRequestFilters = ({ onAdvancedSearchSubmit, loading }) => {
  const dateFromRef = useRef(null)
  const dateToRef = useRef(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [type, setType] = useState(null)
  const [reason, setReason] = useState(null)
  const [user, setUser] = useState(null)
  const [createdDate, setCreatedDate] = useState({ from: null, to: null })

  const items = useSelector(state => state.adminDashboard.items)
  const categories = useSelector(state => state.adminDashboard.itemCategories)
  const users = useSelector(state => state.adminDashboard.users)

  const filteredItems = useMemo(
    () =>
      items?.data?.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })) || [],
    [items]
  )

  const handleSubmit = () => {
    let data = {}
    data.category = category?.value || null
    data.item = item?.map(ite => (ite.value ? ite.value : ite)) || null
    data.adjustment_type = type?.value || null
    data.reason = reason?.value || null
    data.user_id = user?.value || null
    data.createdDate = {
      from: createdDate.from || null,
      to: createdDate.to || null,
    }
    onAdvancedSearchSubmit(data)
  }

  const onClearHandler = () => {
    dateFromRef.current.flatpickr.clear()
    dateToRef.current.flatpickr.clear()
    setCategory(null)
    setItem(null)
    setType(null)
    setReason(null)
    setUser(null)
    setCreatedDate({ from: null, to: null })
    onAdvancedSearchSubmit({})
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Provider</Label>
            {users?.data && (
              <Select
                options={users?.data}
                value={user}
                onChange={setUser}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Item Categories</Label>
            {categories?.data && (
              <Select
                options={categories?.data}
                value={category}
                onChange={setCategory}
              />
            )}
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Items</Label>
            {filteredItems && (
              <Select
                isMulti={true}
                options={filteredItems}
                value={item}
                onChange={setItem}
              />
            )}
          </Col>
          <Col>
            <Label className="form-label">Type</Label>
            <Select
              options={[
                { value: "Increase", label: "Increase" },
                { value: "Decrease", label: "Decrease" },
              ]}
              value={type}
              onChange={setType}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Reason</Label>
            <Select
              options={[
                { value: "Expired", label: "Expired" },
                { value: "Damaged", label: "Damaged" },
                { value: "Lost", label: "Lost" },
                { value: "Found", label: "Found" },
                { value: "Date Correction", label: "Date Correction" },
              ]}
              value={reason}
              onChange={setReason}
            />
          </Col>
          <Col>
            <Label className="form-label">Created From Date</Label>
            <Flatpickr
              ref={dateFromRef}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setCreatedDate(prev => ({
                  ...prev,
                  from: moment(value[0]).format("YYYY-MM-DD"),
                }))
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="mb-3">
        <Row>
          <Col>
            <Label className="form-label">Created To Date</Label>
            <Flatpickr
              ref={dateToRef}
              className="form-control d-block"
              placeholder="dd M,yyyy"
              options={{
                altInput: true,
                altFormat: "Y-m-d",
                dateFormat: "Y-m-d",
              }}
              onChange={value => {
                setCreatedDate(prev => ({
                  ...prev,
                  to: moment(value[0]).format("YYYY-MM-DD"),
                }))
              }}
            />
          </Col>
          <Col></Col>
        </Row>
      </div>

      <div className="d-flex flex-wrap gap-2 mb-4">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={loading}
        >
          {loading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default AdjustmentActionRequestFilters
